import { z } from 'zod'
import { urlValida } from './planificacion'

// Zod 4 compila los objetos con `new Function`, que la CSP del portal bloquea.
z.config({ jitless: true })

/**
 * Contratos de la pestaña Recursos (Fase 5b): los documentos base del
 * cliente, con varios enlaces cada uno. Son del cliente, no del proyecto.
 */

export const TOPE_TITULO_RECURSO = 60
export const TOPE_DESCRIPCION_RECURSO = 1000
export const TOPE_ENLACES = 20

export const ICONOS_RECURSO = [
  'carpeta',
  'marca',
  'imagen',
  'video',
  'documento',
  'tipografia',
  'paleta',
  'enlace',
] as const
export type IconoRecurso = (typeof ICONOS_RECURSO)[number]

export const ETIQUETA_ICONO: Record<IconoRecurso, string> = {
  carpeta: 'Carpeta',
  marca: 'Marca',
  imagen: 'Imagen',
  video: 'Video',
  documento: 'Documento',
  tipografia: 'Tipografía',
  paleta: 'Paleta',
  enlace: 'Enlace',
}

export const enlaceEntrada = z.object({
  nombre: z
    .string({ error: 'Poné un nombre al enlace.' })
    .trim()
    .min(1, 'Poné un nombre al enlace.')
    .max(80, 'El nombre del enlace: hasta 80 caracteres.'),
  url: urlValida('Ese enlace no parece válido. Revisalo.'),
})

export const recursoEntrada = z.object({
  proyectoId: z.uuid(),
  titulo: z
    .string({ error: 'Poné un título.' })
    .trim()
    .min(1, 'Poné un título.')
    .max(
      TOPE_TITULO_RECURSO,
      `El título: hasta ${String(TOPE_TITULO_RECURSO)} caracteres.`,
    ),
  icono: z.enum(ICONOS_RECURSO).default('carpeta'),
  descripcion: z
    .string()
    .max(
      TOPE_DESCRIPCION_RECURSO,
      `La descripción: hasta ${String(TOPE_DESCRIPCION_RECURSO)} caracteres.`,
    )
    .default(''),
  enlaces: z
    .array(enlaceEntrada)
    .max(TOPE_ENLACES, `Hasta ${String(TOPE_ENLACES)} enlaces por recurso.`)
    .default([]),
})
export type RecursoEntrada = z.input<typeof recursoEntrada>

export interface Recurso {
  id: string
  titulo: string
  icono: IconoRecurso
  descripcion: string
  enlaces: { nombre: string; url: string }[]
  dadoDeBaja: boolean
}
